export default "__VITE_ASSET__BPwEvfKE__"